/**
 * Перезапрос данных в полночь по времени системы.
 *
 * Отметки о просмотре действуют до конца дня: сервер перестаёт их отдавать
 * в 00:00, но открытая с вечера доска об этом не узнает — события о смене
 * дня нет. Поэтому экран, показывающий отметки, сам перезапрашивает задачи.
 */

import { useEffect } from "react";

import { useAppDispatch } from "@/app/hooks";
import { msUntilSystemMidnight } from "@/shared/lib/date";

import { api } from "@taskflow/client-core";

/** Запас после полуночи: часы браузера и сервера расходятся на секунды. */
const MARGIN_MS = 5_000;

export function useMidnightRefresh(enabled: boolean): void {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!enabled) return;
    let timer: ReturnType<typeof setTimeout>;
    const schedule = () => {
      timer = setTimeout(() => {
        dispatch(api.util.invalidateTags(["TaskList", "Task"]));
        schedule();
      }, msUntilSystemMidnight() + MARGIN_MS);
    };
    schedule();
    return () => clearTimeout(timer);
  }, [dispatch, enabled]);
}
